module.exports = __webpack_public_path__ + "static/media/varejo-newmobile.3ddfc8de.jpg";